<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.statuschange') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.status"
                :error-messages="statusErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.public') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-row align="center">
              <v-col md="8" >
                <strong class="ml-4" >{{ $t('ticket.hub') }}:</strong>
              </v-col>
              <v-col md="4">
                <v-switch
                  v-model="item.hubCreated"
                  :error-messages="hubCreatedErrors">
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row align="center">
              <v-col md="8" >
                <strong class="ml-4" >{{ $t('ticket.response') }}:</strong>
              </v-col>
              <v-col md="4">
                <v-switch
                  v-model="item.response"
                  :error-messages="responseErrors"
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
        </v-row>              
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ActiontypeForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        name: null,
        namefr: null,
        status: null,
        public: null,
        hubCreated: null,
        response: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    statusErrors() {
      const errors = [];
      if (!this.$v.item.status.$dirty) return errors;
      has(this.violations, 'status') && errors.push(this.violations.status);
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    responseErrors() {
      const errors = [];
      if (!this.$v.item.response.$dirty) return errors;
      has(this.violations, 'response') && errors.push(this.violations.response);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      name: {
        required,
      },
      namefr: {
        required,
      },
      status: {

      },
      public: {

      },
      hubCreated: {

      },
      response: {

      },
    }
  }
};
</script>
